import { UserInfo } from '../lib/types/datatypes';

export const getPlatform = (screenWidth?: number) => {
  const userAgent = window?.navigator?.userAgent?.toLowerCase();
  const isApp = userAgent && /cvs_(.*)_app/.test(userAgent);
  if ((window && (window as unknown as Record<string, unknown>).isApp) || isApp) {
    return 'mapp';
  } else if (screenWidth) {
    if (screenWidth < 768) {
      return 'mweb';
    } else if (screenWidth <= 1024) {
      return 'tweb';
    }
  }
  return 'dweb';
};

export const getTimeStamp = () => {
  const formatDayAndMonth = (date: Date) => {
    let stringMonth = (date.getMonth() + 1).toString();
    stringMonth = stringMonth.length > 1 ? stringMonth : '0' + stringMonth;
    let stringDay = date.getDate().toString();
    stringDay = stringDay.length > 1 ? stringDay : '0' + stringDay;
    return stringMonth + '/' + stringDay + '/' + date.getFullYear();
  };

  const formatAMPM = (date: Date) => {
    const hours = date.getHours() % 24;
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    let stringHour = hours % 12;
    if (stringHour === 0) {
      stringHour = 12;
    }
    const stringMinute = minutes < 10 ? '0' + minutes : minutes;
    const stringTime = stringHour + ':' + stringMinute + ' ' + ampm;
    return stringTime;
  };

  const date = new Date();
  const formattedDate = formatDayAndMonth(date) + ' ' + formatAMPM(date);
  return formattedDate;
};

export const getCookie = (name: string): string => {
  const doc = document;
  const cookies = (doc.cookie || '').split(';');

  for (const cookie of cookies) {
    const cookieParts = cookie.split('=');

    if (cookieParts[0].trim().toLowerCase() === name.toLowerCase()) {
      return (cookieParts[1] || '').trim();
    }
  }

  return '';
};

export const empty = (n: unknown) => {
  return !(n ? (typeof n === 'object' ? (Array.isArray(n) ? !!n.length : !!Object.keys(n).length) : true) : false);
};

export const getCarePassEnrollStatus = (status?: string): string | undefined => {
  let value;
  if (status === 'ENROLLED') {
    value = 'carepass:true:enrolled';
  } else if (status === 'ON_HOLD') {
    value = 'carepass:true:onhold';
  } else if (status === 'UN_ENROLLED') {
    value = 'carepass:false:unenrolled';
  } else if (status === 'CANCEL_INITIATED') {
    value = 'carepass:true:ci';
  } else if (status === 'ENROLL_IN_PROGRESS') {
    value = 'carepass:true:eip';
  } else if (status === 'NOT_ENROLLED') {
    value = 'carepass:false';
  }
  return value;
};

export interface iAnalytics {
  type: string;
  payload: Record<string, unknown>;
}

export const sendAdobeTag = (tagData: iAnalytics, userInfo: UserInfo = {}) => {
  if (!tagData) return;
  const loadTag = () => {
    let analyticsData = tagData.payload;
    const rxTied = userInfo?.rxDetails?.primaryRxTied === 'Y' ? true : false;
    const platform = getPlatform(screen.width);
    const subsection = 'cvs|' + platform + '|account|';
    const timeStamp = getTimeStamp();
    // v31
    const v31 = rxTied === true ? 'rx registered' : 'rx unregistered';
    // v35
    const v35 = empty(userInfo?.personal?.emailAddress) ? false : true;

    // v59
    const v59 = userInfo?.extraCareDetails?.extraCareTied === 'Y' ? 'true' : 'false';
    //  v58
    const carePassEnrollmentStatus = getCarePassEnrollStatus(
      userInfo?.carePassEnrollmentInfo?.carePassEnrollmentStatus,
    );
    let v58: string | undefined = 'no';
    if (carePassEnrollmentStatus) {
      v58 = carePassEnrollmentStatus;
    }

    const ecNumber = userInfo?.extraCareDetails?.extracareCardNumber;
    const ecFingerprintId = getCookie('ecFingerprintId') !== '' ? 'yes' : 'no';

    if (tagData.type === 'view') {
      analyticsData = {
        ...analyticsData,
        hierarchy: subsection,
        previous_page_name: decodeURIComponent(getCookie('gpv_e4')),
        previous_page_url: decodeURIComponent(getCookie('gpv_c10')),
        platform,
        bb_cplptest: decodeURIComponent(getCookie('bb_cplptest')),
        bb_splptest: decodeURIComponent(getCookie('bb_splptest')),
        breadcrumb: '',
        design: platform,
        state_authentication: v31,
        state_logged_in: v35,
        bb_sabtest: getCookie('bb_sabtest'),
        domain: document.domain,
        local_time: timeStamp,
        environment: window.location.hostname === 'www.cvs.com' ? 'prod' : 'dev',
        adobe_mid: 'D=mid',
        page_url: window.location.href.split('?')[0],
        user_agent: 'D=User-Agent',
        carepass_status: v58,
        state_extracare_link: v59,
        ec_card: ecNumber,
        cc: 'USD',
      };

      (window as unknown as Record<string, Record<string, (data: Record<string, unknown>) => void>>)['utag'].view(analyticsData);
    }

    if (tagData.type === 'link') {
      analyticsData = {
        ...analyticsData,
        site_name: 'www.cvs.com',
        platform,
        'cp.ecFingerprintId': ecFingerprintId,
      };
      (window as unknown as Record<string, Record<string, (data: Record<string, unknown>) => void>>)['utag'].link(analyticsData);
    }
  };

  if (window && (window as unknown as Record<string, unknown>)['utag']) {
    loadTag();
  }
};

export const sendAdobeLinkTag = (linkObj?: Record<string, unknown>, userInfo?: UserInfo) => {
  sendAdobeTag(
    {
      type: 'link',
      payload: linkObj || {},
    },
    userInfo,
  );
};
